import React, { useState, useEffect } from "react";
import "./roles.css";
import Breadcrumbs from "../layout/breadcrumb";
import { useSearchParams, useNavigate } from "react-router-dom";
import { AUTENTICATE_API } from "../../services/apiCalls/authApi";
import { toast } from "react-toastify";

const Role = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const roleId = searchParams.get("roleId");

  const [roleName, setRoleName] = useState("");
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        let roleData = {};
        let roleModules = [];

        if (roleId) {
          // Fetch role details for update
          const roleResponse = await AUTENTICATE_API.getRoleById(roleId);
          if (roleResponse.status === 200 && roleResponse.roles.length > 0) {
            const roleDetails = roleResponse.roles[0]; // Extract first role
            roleData = {
              role_name: roleDetails.role_name,
              modules: roleDetails.modules.map((module) => module.id),
            };
            roleModules = roleDetails.modules; // Capture detailed modules
          } else {
            throw new Error("Failed to fetch role details");
          }
        }

        // Fetch modules list
        const modulesResponse = await AUTENTICATE_API.modulesList();
        if (modulesResponse && modulesResponse.status === 200) {
          const modulesData = modulesResponse.modules;
          const modulesWithSelection = modulesData.map((module) => ({
            ...module,
            selected: roleData.modules
              ? roleData.modules.includes(module.module_id) // Compare IDs
              : false,
          }));

          if (isMounted) {
            setModules(modulesWithSelection);
            setRoleName(roleData.role_name || "");
          }
        } else {
          throw new Error("Error fetching modules list!");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error(error.message);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [roleId]);

  const handleModuleChange = (id) => {
    setModules((prevModules) =>
      prevModules.map((module) =>
        module.module_id === id
          ? { ...module, selected: !module.selected }
          : module
      )
    );
  };

  const handleToggleAll = (isChecked) => {
    setModules((prevModules) =>
      prevModules.map((module) => ({ ...module, selected: isChecked }))
    );
  };

  const isAllChecked = modules.every((module) => module.selected);

  const handleSave = async () => {
    const selectedModules = modules
      .filter((module) => module.selected)
      .map((module) => module.module_id);
    const payload = {
      role_name: roleName,
      module: selectedModules,
      ...(roleId && { role_id: parseInt(roleId) }),
    };
    // console.log(payload);
    // return;

    try {
      const response = roleId
        ? await AUTENTICATE_API.updateRole(payload)
        : await AUTENTICATE_API.createRole(payload);

      toast.success(`Role ${roleId ? "updated" : "created"} successfully!`);
      console.log("API Response:", response);
      navigate("/role_permissions");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error saving role");
    }
  };

  const organizeModulesInColumns = (modules, rowsPerColumn) => {
    const columns = [];
    for (let i = 0; i < modules.length; i += rowsPerColumn) {
      columns.push(modules.slice(i, i + rowsPerColumn));
    }
    return columns;
  };

  const moduleColumns = organizeModulesInColumns(modules, 10);

  return (
    <>
      <Breadcrumbs
        title="Roles & Permissions"
        menu="Roles & Permissions"
        link={roleId ? "Edit Role" : "Create Role"}
      />
      <div className="container-roles">
        <div className="field-container-role">
          <label
            htmlFor="roleName"
            className="label"
            style={{ fontSize: "14px" }}
          >
            Role Name:
          </label>
          <input
            id="roleName"
            type="text"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
            className="input"
          />
        </div>
        {loading ? (
          <p style={{ fontSize: "15px" }}>Loading modules...</p>
        ) : (
          <div className="modules-container">
            <span
              style={{
                fontSize: "20px",
                fontWeight: "500",
              }}
            >
              Modules
            </span>
            <div className="module-item">
              <label>
                <input
                  type="checkbox"
                  checked={isAllChecked}
                  onChange={(e) => handleToggleAll(e.target.checked)}
                />
                Select/Deselect All
              </label>
            </div>
            <div className="module-columns">
              {moduleColumns.map((column, colIndex) => (
                <div key={colIndex} className="module-column">
                  {column.map((module) => (
                    <div key={module.module_id} className="module-item">
                      <label>
                        <input
                          type="checkbox"
                          checked={module.selected}
                          onChange={() => handleModuleChange(module.module_id)}
                        />
                        {module.module_name}
                      </label>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
        <button onClick={handleSave} className="save-button">
          {roleId ? "Update Role" : "Create Role"}
        </button>
      </div>
    </>
  );
};

export default Role;
